import { useTranslation } from 'react-i18next';
import { Field } from 'react-final-form';
import { printGuestType } from 'lib/util/util';
import { GuestType } from 'models/product';

interface Props {
  guestType: GuestType;
  minimumParticipants: number;
  maximumParticipants: number;
  className?: string;
}

const range = (start: number, stop: number): number[] => {
  if (start > stop) {
    return [];
  }

  return [...Array(stop - start + 1).keys()].map((item) => item + start);
};

export const GuestTypeListItem = ({
  guestType,
  minimumParticipants,
  maximumParticipants,
  className,
}: Props) => {
  const { t } = useTranslation();

  return (
    <li className={className} key={guestType.key}>
      <Field name={`guestCount.${guestType.key}`}>
        {({ input }) => (
          <label className="widget-calendar-pax-select">
            <p className="widget-calendar-selectTitle">{printGuestType(guestType, t)}</p>
            <p className="widget-calendar-select__num">{input.value || '0'}</p>
            <select
              className="widget-calendar-select__item"
              onChange={(e) => input.onChange(e.target.value)}
            >
              {range(minimumParticipants, maximumParticipants).map((c) => (
                <option value={c} key={c}>
                  {c}
                </option>
              ))}
            </select>
          </label>
        )}
      </Field>
    </li>
  );
};
